export interface ILedger {
  id: string
  name: string
  unit: number
  perUnit: number
  vatPercent: number      // example: 0.07
  issueDate: Date
  type: 'rev'|'exp'
}

export type RevenueStatus = 'created'|'invoiced'|'received'
export type ExpenseStatus = 'created'|'paid'

export const revenueStatuses = [
  'created',
  'invoiced',
  'received',
]

export const expenseStatuses = [
  'created',
  'paid',
]

export type DocumentType = 'receipt' | 'invoice' | 'payment_voucher' | 'receipt_voucher'

export interface IDocumentItem {
  name: string
  unit: number
  perUnit: number
  total: number
}

export interface IDocument {
  code: string
  issueDate: Date
  items: IDocumentItem[]
  customer: Customer
  totalAmount: number

  documentType(): DocumentType
}

export interface IRevenue extends ILedger, IDocumentItem {
  invoiceId: string
  invoiceHash: string
  customerId: string
  status: RevenueStatus
}

export interface IExpense extends ILedger {
  receiptRefCode: string
  paidDate: Date|undefined
  payeeId: string
  status: ExpenseStatus
}

export interface Customer {
  code: string
  name: string
  address: string
  taxId: string
  phone: string
}

export interface IMeter {
  id: string
  collectDate: Date|undefined
  monthCode: string
  // customized field for Momospace.
  floor1to5: number
  floor2: number
  floor3: number
  shop: number
  // Last collected value
  floor1to5Last: number
  floor2Last: number
  floor3Last: number
  shopLast: number
}

export const emptyCustomer = (): Customer => {
  return {
    code: '',
    name: '',
    address: '',
    taxId: '',
    phone: '',
  }
}

export type VoucherStatus = 'created'|'accepted'
export type VoucherType = 'receipt'|'payment'

/**
 * Customer deposit certain amount.
 */
export interface IVoucher {
  id: string
  name: string
  unit: number
  perUnit: number
  customerId: string
  issueDate: Date
  type: VoucherType
  status: VoucherStatus

  createDocument(): IDocument
}

